import { Button, Input, Select, Form, Modal, Checkbox, Space, Row, Col, Typography } from "antd";
import { useState } from "react";
import { useGetBrandsQuery } from "../../redux/services/brandApi";
import { useGetLocationsQuery } from "../../redux/services/locationsApi";
import { useGetUsersQuery } from "../../redux/services/userApi";
import { useGetPartnersQuery } from "../../redux/services/partnerApi";
import { DownOutlined, UpOutlined } from "@ant-design/icons";
import { userTypeOptions } from "../../constants/helperConstants";

const { Option } = Select;

const UserFilters = (props: any) => {
  const { applyFilters } = props;
  const [form] = Form.useForm();
  const [showAll, setShowAll] = useState<boolean>(false);
  const [filters, setFilter] = useState<any>({});

  const { data: brandsData } = useGetBrandsQuery({ all_pages: true });
  const brands = brandsData?.brands || [];

  const { data: partnersData } = useGetPartnersQuery({ all_pages: true });
  const partners = partnersData?.partners || [];

  const { data: cityLocationData } = useGetLocationsQuery({
    all_pages: true,
    location_type: "city"
  });
  const cityLocations = cityLocationData?.locations || [];

  const onReset = () => {
    setFilter({});
    form.resetFields();
    applyFilters(form.getFieldsValue());
  };

  const onApply = (values: any) => {
    setFilter(values);
    applyFilters(values);
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log(errorInfo);
  };
  return (
    <div>
      <div style={{ display: "flex", alignItems: "center", marginBottom: 20, gap: 10 }}>
        <Typography style={{ fontWeight: 600, fontSize: 16 }}>Use Filter</Typography>
      </div>
      <Form
        name="filter_form"
        form={form}
        onFinish={onApply}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
      >
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label="" name="name">
              <Space.Compact style={{ width: "100%" }}>
                <Input
                  disabled
                  value={"Name"}
                  style={{
                    width: "200px",
                    color: "rgba(0, 0, 0, 0.65)",
                    cursor: "auto",
                    paddingLeft: 8
                  }}
                />
                <Form.Item name="name" noStyle>
                  <Input placeholder="Enter Name" />
                </Form.Item>
              </Space.Compact>
            </Form.Item>
            <Form.Item label="" name="mobile">
              <Space.Compact style={{ width: "100%" }}>
                <Input
                  disabled
                  value={"Mobile No"}
                  style={{
                    width: "200px",
                    color: "rgba(0, 0, 0, 0.65)",
                    cursor: "auto",
                    paddingLeft: 8
                  }}
                />
                <Form.Item name="mobile" noStyle>
                  <Input placeholder="Enter Mobile No" />
                </Form.Item>
              </Space.Compact>
            </Form.Item>
            <Form.Item label="" name="role_type">
              <Space.Compact style={{ width: "100%" }}>
                <Input
                  disabled
                  value={"Role Type"}
                  style={{ width: "200px", color: "rgba(0, 0, 0, 0.65)", cursor: "auto" }}
                />
                <Form.Item name="role_type" noStyle>
                  <Select
                    placeholder="Select role"
                    allowClear
                    showSearch
                    optionFilterProp="children"
                    filterOption={(input, option: any) =>
                      option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    <Option value="central_tech">Central Tech</Option>
                    <Option value="city_manager">City Manager</Option>
                    <Option value="field_agent">Field Agent</Option>
                    <Option value="mis">MIS</Option>
                    <Option value="management">Management</Option>
                    <Option value="partner_manager">Partner Manager</Option>
                    <Option value="super_user">Super User</Option>
                    <Option value="zonal_manager">Zonal Manager</Option>
                    <Option value="finance_controller">Finance Controller</Option>
                  </Select>
                </Form.Item>
              </Space.Compact>
            </Form.Item>

            <Form.Item label="" name="brand_id">
              <Space.Compact style={{ width: "100%" }}>
                <Input
                  disabled
                  value={"Brand"}
                  style={{ width: "200px", color: "rgba(0, 0, 0, 0.65)", cursor: "auto" }}
                />
                <Form.Item name="brand_id" noStyle>
                  <Select
                    placeholder="Select brand"
                    allowClear
                    showSearch
                    optionFilterProp="children"
                    filterOption={(input, option: any) =>
                      option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {brands?.map((brand: any) => (
                      <Option key={brand?.name} value={brand?.id}>
                        {brand?.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Space.Compact>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="" name="email">
              <Space.Compact style={{ width: "100%" }}>
                <Input
                  disabled
                  value={"Email"}
                  style={{
                    width: "200px",
                    color: "rgba(0, 0, 0, 0.65)",
                    cursor: "auto",
                    paddingLeft: 8
                  }}
                />
                <Form.Item name="email" noStyle>
                  <Input placeholder="Enter Email" />
                </Form.Item>
              </Space.Compact>
            </Form.Item>
            <Form.Item label="" name="location_id">
              <Space.Compact style={{ width: "100%" }}>
                <Input
                  disabled
                  value={"City"}
                  style={{ width: "200px", color: "rgba(0, 0, 0, 0.65)", cursor: "auto" }}
                />
                <Form.Item name="location_id" noStyle>
                  <Select
                    placeholder="Select city"
                    allowClear
                    showSearch
                    optionFilterProp="children"
                    filterOption={(input, option: any) =>
                      option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {cityLocations?.map((city: any) => (
                      <Option key={city?.name} value={city?.id}>
                        {city?.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Space.Compact>
            </Form.Item>

            <Form.Item label="" name="partner_id">
              <Space.Compact style={{ width: "100%" }}>
                <Input
                  disabled
                  value={"Partner"}
                  style={{ width: "200px", color: "rgba(0, 0, 0, 0.65)", cursor: "auto" }}
                />
                <Form.Item name="partner_id" noStyle>
                  <Select
                    placeholder="Select partner"
                    allowClear
                    showSearch
                    optionFilterProp="children"
                    filterOption={(input, option: any) =>
                      option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {partners?.map((partner: any) => (
                      <Option key={partner?.name} value={partner?.id}>
                        {partner?.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Space.Compact>
            </Form.Item>

            <Form.Item label="">
              <Space.Compact style={{ width: "100%" }}>
                <Input
                  disabled
                  value={"User Type"}
                  style={{
                    width: "200px",
                    color: "rgba(0, 0, 0, 0.65)",
                    cursor: "auto",
                  }}
                />

                <Form.Item name="user_type" noStyle>
                  <Select
                    placeholder="Select User Type"
                    allowClear
                    showSearch
                    mode="multiple"
                    optionFilterProp="children"
                    filterOption={(input, option: any) =>
                      option?.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                    options={userTypeOptions}
                  />
                </Form.Item>
              </Space.Compact>
            </Form.Item>
          </Col>
        </Row>

        <div style={{ marginBottom: 20, gap: 6, display: "flex" }}>
          <Button type="default" onClick={onReset} style={{ color: "green" }}>
            Clear Filter
          </Button>
          <Button form="filter_form" key="submit" htmlType="submit" type="primary">
            Apply Filter
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default UserFilters;
